var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"font-monospace text-nowrap border rounded px-2 py-1",class:_vm.cssClass},[_vm._v(_vm._s(_vm.formattedAmount)+" "),_c('span',{attrs:{"title":"KoLe-Währungs-EQUI-valent"}},[_vm._v("🦄")])])}
var staticRenderFns = []

export { render, staticRenderFns }